import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ModalLayoutRightComponent, NModalLayoutRight } from '../../../../ui/modal/modal-layout-right.component';
/**
 * Block data mered with model data
 */
export namespace NCmsProductSizeGuide {
    export const BLOCK_ID = 'cms-product-size-guide';
    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}
    export interface IBlockDataContent {
        components: NICmsContentComponent.IData[];
    }
}
@Component({
    selector: 'cms-product-size-guide',
    templateUrl: './cms-product-size-guide.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            :host {
                display: inline;
            }
        `
    ],
    standalone: true,
    imports: [ICmsClientModule, ModalLayoutRightComponent]
})
@ICmsComponent<CmsProductSizeGuideComponent>({
    id: NCmsProductSizeGuide.BLOCK_ID,
    block: {
        url: NCmsProductSizeGuide.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Product size guide modal',
    description: 'Product size guide modal component',
    fields: [
        <NICmsContentField.IComponentsField>{
            key: 'components',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            itemName: 'component',
            default: []
        }
    ]
})
@DfCmsModal({
    id: NCmsProductSizeGuide.BLOCK_ID,
    name: 'Product size guide modal',
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName)
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
export class CmsProductSizeGuideComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsProductSizeGuide.IBlockDataContent;
}
